exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s-box[data-v-0a0b8012]{-webkit-box-flex:1;-ms-flex:1;flex:1;background:#fff;height:28px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}img[data-v-0a0b8012]{display:block}", ""]);

// exports
